<template>
  <div class="follow-clue-log">
    <div
      v-if="data.next_follow"
      class="follow-next-box"
      :class="{'edit-follow-next-box': isEidt}"
      @mouseenter="handleFollow"
      @mouseleave="handleFollow"
    >
      <a-form :form="form">
        <a-form-item
          v-if="!isEidt"
          label="下次跟进："
        >
          <div
            class="follow-next-content clearfix"
          >
            <span
              class="follow-next-time"
              :class="{'follow-overtime':data.next_follow.status * 1 === 3}"
            >
              {{ data.next_follow.time ===0 ? '' : data.next_follow.time || '--' }}
              {{ data.next_follow.time_title }}
            </span>
            <template v-if="isFollowRight">
              <a
                v-if="!data.next_follow.value && data.next_follow.time === 0"
                href="javascript:;"
                @click="handleEditFollowTime"
              >设置</a>
              <a-button
                v-if="data.next_follow.is_follow === 1"
                :class="{'finish-btn': isFollowBtnShow}"
                class="finish-default-btn"
                @click="handleFinishFollow"
              >
                完成跟进
              </a-button>

              <a
                v-if="data.next_follow.value && data.next_follow.time"
                href="javascript:;"
                class="follow-next-edit-btn"
                @click="handleEditFollowTime"
              >修改</a>
              <a
                v-if="!data.next_follow.value && !!data.next_follow.time && (data.next_follow.time !==0)"
                href="javascript:;"
                class="follow-next-edit-btn"
                @click="handleDelete"
              >删除</a>
            </template>

            <div
              v-if="!!data.next_follow.field"
              class="clue-follow-log-time"
            >
              {{ data.next_follow.field }}：{{ data.next_follow.value }}
            </div>
          </div>
        </a-form-item>
        <div
          v-else
          class="eidt-follow-next clearfix"
        >
          <a-form-item label="下次跟进：">
            <a-date-picker
              v-decorator="['followtime', {
                rules: [{ required: !!data.next_follow.value, message: '请选择下次跟进时间'}],
                initialValue:data.next_follow.time ? $moment(data.next_follow.time, dateFormat) :null
              }]"
              :disabled-date="disabledDate"
              placeholder="下次跟进时间"
              @change="onChangeTime"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              :loading="confirmLoading"
              @click="handleSumbit"
            >
              {{ $t('message["915"]') }}
            </a-button>
            <a-button
              @click="handleReset"
            >
              {{ $t('message["896"]') }}
            </a-button>
          </a-form-item>
        </div>
      </a-form>
      <!-- 完成跟进弹窗 -->
      <follow-modal
        :data="{clueid: clueId, id: data.next_follow.id}"
        :follow-data="{field: followLogs.next_follow_field || '', value: followLogs.next_follow_value || '', time: followLogs.next_followup_time || ''}"
        :visible.sync="isShowFollowModal"
        @finishHandle="finishHandle"
      />
    </div>
    <div class="follow-clue-log-list">
      <div
        v-for="(item, index) in data.followlog"
        :key="index"
        class="follow-clue-log-item"
      >
        <div class="clue-follow-log-time">
          {{ item.addtime }}
          {{ item.truename }}
        </div>
        <div
          v-if="!!item.fieldname"
          class="clue-follow-log-time"
        >
          {{ item.fieldname }}：{{ item.fieldvalue }}
        </div>
        <div class="clue-follow-log-content">
          {{ item.content }}
        </div>
        <div
          v-for="(file, i) in item.file"
          :key="i"
          class="clue-follow-log-file"
        >
          <a
            v-if="file.file_type.indexOf('image/') > -1"
            href="javascript:;"
            class="file"
            @click="handleclickGallery(item.file, i)"
          >{{ file.file_name }}</a>
          <a
            v-else
            class="file"
            :href="file.file_url"
          >{{ file.file_name }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FollowModal from '../clue/components/FollowModal'
import eventBus from '@/lib/eventBus'
// import Gallery from '@/components/pc/Gallery'
export default {
  components: {
    FollowModal
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isFollowRight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD',
      form: this.$form.createForm(this),
      confirmLoading: false,
      isEidt: false,
      followtime: null,
      isShowFollowModal: false,
      isFollowBtnShow: false
    }
  },
  computed: {
    ...mapState('inquery/clue', ['followLogs']),
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    clueId () {
      return this.$route.params.id || ''
    }
  },
  async created () {
    this.followtime = this.data.next_follow.time
  },
  beforeDestroy () {
  },
  methods: {
    ...mapActions('inquery/clue', ['fetchFollowLog']),
    ...mapActions('inquery/detailData', [
      'eidtClueFollowTime'
    ]),
    handleclickGallery (fileList, i) {
      let item = fileList[i]
      fileList.forEach(item2 => {
        item2.title = '下载'
      })
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    },
    handleSumbit () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return
          const params = {
            clueid: this.clueId,
            followtime: this.followtime,
            id: this.data.next_follow.id
          }
          this.confirmLoading = true
          const chain = await this.eidtClueFollowTime(params)
          chain
            .onSuccess((res = {}) => {
              this.data.next_follow.time = this.followtime
              this.$message.success('修改成功！')
              this.handleEditFollowTime()
              eventBus.$emit('fetchInquiryDetail')
            })
            .onNetSuccess(raw => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleReset () {
      this.handleEditFollowTime()
      this.form.resetFields()
    },
    handleEditFollowTime () {
      this.isEidt = !this.isEidt
    },
    onChangeTime (time, timestring) {
      this.followtime = timestring
    },
    async handleDelete () {
      const params = {
        clueid: this.clueId,
        followtime: 0,
        id: this.data.next_follow.id
      }
      const chain = await this.eidtClueFollowTime(params)
      chain
        .onSuccess((res = {}) => {
          this.followtime = 0
          this.data.next_follow.time = this.followtime
          this.$message.success('删除成功')
          eventBus.$emit('fetchInquiryDetail')
        })
    },
    async handleFinishFollow () {
      const chain = await this.fetchFollowLog({ clueid: this.clueId })
      chain.onSuccess(raw => {
        this.isShowFollowModal = true
      })
      this.isShowFollowModal = true
    },
    handleFollow () {
      this.isFollowBtnShow = !this.isFollowBtnShow
    },
    finishHandle () {
      // this.data.next_follow.status = 1
      this.data.next_follow.is_follow = 0
      eventBus.$emit('fetchInquiryDetail')
    },
    disabledDate (val) {
      return val && val < this.$moment().startOf('day')
    }
  }
}
</script>

<style lang="scss" scoped>
.follow-clue-log {
  //padding: 24px 0;
  width: 416px;
  .follow-clue-log-item{
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebebeb;
    line-height: 24px;
    .clue-follow-log-content{
      color: #666;
      margin: 16px 0;

    }
    .clue-follow-log-file{
      display: block;
      margin-bottom: 8px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
  .follow-clue-log-list{
    margin-top: 16px;
  }
  .follow-overtime{
    color: #F57676;
  }
}
.follow-next-edit-btn{
  float: right;
}
.follow-next-box::v-deep{
  background: #F5F8FB;
  padding: 12px 16px 12px  16px;
  border-radius: 4px;
  &.edit-follow-next-box{
    padding-right: 0;
  }
  .ant-form{
    .ant-row{
       margin-bottom: -4px !important;
      .ant-form-item-label{
        width: 70px;
        color: #666;
      }
      .ant-form-item-label label::after {
        content: ":" !important;
        position: relative;
        top: -.5px;
        margin: 0 8px 0 2px;
    }
      .ant-form-item-control-wrapper{
        padding-left: 70px;
        .finish-default-btn{
          display: none;
          &.finish-btn{
            display: inline-block;
          }
        }
      }
      .ant-calendar-picker-input{
        width: 170px;
      }
    }
    .eidt-follow-next{
      .ant-form-item{
        float: left;
        &:last-child{

          .ant-form-item-control-wrapper{
            padding-left: 0;

          }
           .ant-btn{
              margin-right: 0;
              margin-left: 8px;
            }
        }
      }
    }
  }
}
</style>
